import { createContext } from "react";

export type AdminTheme = "light" | "dark" | "system";

export interface AdminThemeContextType {
  theme: AdminTheme;
  effectiveTheme: "light" | "dark";
  setTheme: (theme: AdminTheme) => void;
}

export const AdminThemeContext = createContext<AdminThemeContextType | null>(
  null,
);
